import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function AuthCallback() {
  const navigate = useNavigate();
  const location = useLocation();
  const hasProcessed = useRef(false);
  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;
    const sessionId = location.hash.split("session_id=")[1]?.split("&")[0] || "";
    axios.post(`${API}/auth/google`, { session_id: sessionId }, { withCredentials: true })
      .then(({ data }) => navigate("/admin", { state: { user: data }, replace: true }))
      .catch(() => navigate("/admin/login", { state: { error: "Google sign-in failed or this account is not authorized for the dashboard." }, replace: true }));
  }, [location, navigate]);
  return null;
}
